// src/App.js
import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Projects from './components/Projects';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './assets/CSS/styles.css';
import deepImage from './assets/Images/OPM_DP.JPG';


const App = () => {
    return (
        <main>
            <Header />
            <section id="image">
                <div>
                <img className="img" src={deepImage} alt="Deep" />
                </div>
            </section>
            <Hero />
            <About />
            <Projects />
            <Contact />
            <Footer />
        </main>
    );
};

export default App;
